module.exports = __webpack_public_path__ + "img/arrow-down-icon-white.8a4ddd1e.svg";